import Select from 'react-select';

type Option = { value: any; label: string };

interface SelectGenericoProps<T> {
  value?: T;
  onChange: (item?: T | null) => void;
  onBlur?: () => void;
  items: T[];
  getOptionLabel: (item: T) => string;
  getOptionValue: (item: T) => any;
  id?: string;
  name?: string;
  isClearable?: boolean;
}

export function SelectGenerico<T>({ value, onChange, onBlur, items, getOptionLabel, getOptionValue, id, name, isClearable = true }: SelectGenericoProps<T>) {

  const options: Option[] = items.map((item) => ({ label: getOptionLabel(item), value: getOptionValue(item) }));

  const selectedOption = value ?
    options.find((opt) => opt.value === getOptionValue(value)) :
    null;

  return (
    <Select
      inputId={id}
      name={name}
      isClearable={isClearable}
      options={options}
      value={value ? selectedOption : null}
      onChange={(selected) => {
        if (selected) {
          const selectedItem = items.find(
            (item) => getOptionValue(item) === selected.value
          );
          onChange(selectedItem);
        } else {
          onChange(null);
        }
      }}
      onBlur={onBlur}
    />
  );
}
